import { useAppSelector } from '@/store/hooks';
import { selectIsLoadingRowsCount } from '@/features/query-builder/queryBuilderSlice';
import { useLoadRowsCount } from '..';

let countRef: Maybe<number> = null;
export const useLoadRowsCount_LEGACY = (skip = false) => {
  const { data } = useLoadRowsCount(skip);
  const isLoading = useAppSelector(selectIsLoadingRowsCount);

  const rowCount = data?.rowCount ?? null;

  if (rowCount !== null) {
    countRef = rowCount;
  }

  if (isLoading) return null;

  return countRef;
};
